import * as React from "react";
import { cn } from "@/lib/utils";

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      data-focus-visible-ring=""
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-card/40 px-3 py-1 text-sm",
        "placeholder:text-muted-foreground/70 transition-colors",
        "focus-visible:border-ring/70 focus-visible:bg-card disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
